<template>
  <div class="main">
    <!-- <van-nav-bar
      class="cnavbar"
      title="积分兑换"
      :border="false"
      left-arrow
      @click-left="handleBack"
    /> -->
    <!-- fb4948 -->

    <van-image
      fit="cover"
      class="exchange-bg"
      :src="require('../../static/images/v3/points-exchange-header.png')"
    />

    <div class="content">
      <!-- 用户信息 -->
      <div class="user-info">
        <div class="store-info">
          <div>
            <van-image
              fit="cover"
              class="account"
              :src="require('../../static/images/account.png')"
            />
          </div>

          <div>
            <div class="store-info-name">
              {{ storeInfo.storeName || "" }}
            </div>
            <div class="store-info-address">
              {{ storeInfo.province || "" }}{{ storeInfo.city || ""
              }}{{ storeInfo.county || "" }}{{ storeInfo.address || "" }}
            </div>
          </div>
        </div>

        <div class="user-info-header">
          <!-- <div>
            <van-image
              fit="cover"
              class="account"
              :src="require('../../static/images/account.png')"
            />
          </div> -->
          <div style="width: 100%">
            <van-row class="">
              <van-col span="24" class="account-mobile">
                <div>{{ account }}</div>
                <div class="account-mobile-logout" @click="handleRecord">
                  兑换记录
                </div>
              </van-col>
            </van-row>
            <div class="account-panel">
              <van-row>
                <van-col span="12" class="account-descr">
                  <!-- <van-image
                    fit="cover"
                    class="account-descr-picon"
                    :src="require('../../static/images/v3/jifen.png')"
                  /> -->
                  <span>
                    <span> 移动积分 </span>
                  </span>
                </van-col>
                <van-col span="12" class="account-descr">
                  <!-- <van-image
                    fit="cover"
                    class="account-descr-picon"
                    :src="require('../../static/images/v3/jifen.png')"
                  /> -->
                  <span>
                    <span> 磁石账户 </span>
                  </span>
                </van-col>
              </van-row>
              <van-row class="">
                <van-col span="12" class="account-descr">
                  <span>
                    <span class="account-descr-points">{{ points }}</span>
                  </span>
                </van-col>
                <van-col span="12" class="account-descr">
                  <div>
                    <span class="account-descr-points">0</span>
                  </div>
                </van-col>
              </van-row>
            </div>

            <van-divider style="padding: 10px 0 5px; margin: 0" />

            <van-row class="">
              <van-col span="24" class="account-exchange-tip">
                <!-- <van-image
                    fit="cover"
                    class="account-descr-picon"
                    :src="require('../../static/images/v3/jifen.png')"
                  /> -->
                <span>
                  <span> 移动积分可兑换 </span>
                  <span class="account-descr-points">{{ parseInt(points / 120) }}</span>
                  <span> 磁石 </span>
                </span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>

      <div class="exchange-record" @click="showActionSheet = true">
        <van-image
          fit="cover"
          class="exchange-record-icon"
          :src="require('../../static/images/v3/logout.png')"
        />
      </div>
    </div>

    <div v-if="isProduct" class="info-exchange-panel">
      <van-image
        fit="cover"
        class="info-exchange-title"
        :src="require('../../static/images/v3/info-exchange-title.png')"
      />
    </div>

    <div v-if="isProduct" style="margin-top: 15px">
      <div
        v-for="(item, index) in productList"
        :key="index"
        class="product-item"
      >
        <van-image fit="cover" class="product-item-img" :src="item.goodsImg" />
        <div class="product-item-title van-ellipsis">
          {{ item.goodsName }}
        </div>

        <!-- <div class="product-item-points">{{ item.points }}积分</div> -->
        <div class="product-item-points">{{ item.threeValue }}磁石</div>

        <div class="product-item-btn" @click="handleProduct(item)">
          <span class="product-item-span">立即兑换</span>
        </div>
      </div>
    </div>

    <!-- 券 -->
    <div v-if="!isProduct" style="margin-top: 15px">
      <div class="coupon-bg">
        <div class="coupon-bg-header">
          <van-image
            fit="cover"
            class="coupon-bg-header-title"
            :src="require('../../static/images/v3/coupon-title.png')"
          />
        </div>
        <div class="coupon-bg-panel">
          <div class="coupon-bg-img"></div>

          <div class="coupon-bg-img"></div>

          <div class="coupon-bg-img"></div>
        </div>

        <div style="margin-top: 15px; padding-left: 8px">
          <div class="coupon-change-item">123</div>
          <div class="coupon-change-item">123</div>
          <div class="coupon-change-item">123</div>
        </div>
      </div>
    </div>

    <van-popup
      v-model="showConfirmPopup"
      round
      position="bottom"
      :style="{ height: '410px' }"
    >
      <div class="pop-product-item">
        <!-- header -->
        <div style="display: flex">
          <div>
            <van-image
              fit="cover"
              round
              class="pop-product-item-img"
              :src="popupProduct.goodsImg"
            />
          </div>
          <div style="padding-left: 10px">
            <div class="pop-product-item-title">
              {{ popupProduct.goodsName }}
            </div>
            <div class="pop-product-item-point">
              <!-- {{ popupProduct.points }}积分 -->
              {{ popupProduct.threeValue }}磁石
            </div>
          </div>
        </div>

        <!-- content -->
        <div class="pop-product-item-count">
          <div class="pop-product-item-tiplab">所需磁石</div>
          <div>{{ popupProduct.threeValue * stepCountVal }}磁石</div>
        </div>

        <div class="pop-product-item-count">
          <div class="pop-product-item-tiplab">购买数量</div>
          <van-stepper
            v-model="stepCountVal"
            theme="round"
            button-size="22"
            disable-input
          />
        </div>

        <div style="padding-top: 20px; font-weight: 600; font-size: 14px">
          支付方式
        </div>

        <van-radio-group v-model="radio">
          <div class="pop-product-item-count">
            <div class="pop-product-item-tiplab">磁石支付</div>
            <van-radio name="1" checked-color="#ff533c"></van-radio>
          </div>

          <div class="pop-product-item-count">
            <div class="pop-product-item-tiplab">微信支付</div>
            <van-radio name="2" checked-color="#ff533c"></van-radio>
          </div>
        </van-radio-group>

        <!-- footer -->
        <van-submit-bar
          :price="popupProduct.threeValue * stepCountVal * 100"
          label="总计："
          currency=""
          text-align="left"
          :decimal-length="0"
          button-text="立即兑换"
          tip-icon="info-o"
          @submit="handleConfirm"
        />
      </div>
    </van-popup>

    <van-popup
      v-model="showPopup"
      position="center"
      :close-on-click-overlay="false"
      :style="{ minHeight: '440px', width: '80%' }"
      round
    >
      <div class="pop">
        <!-- header -->
        <div class="pop-header">
          <div class="pop-header-title">短信验证</div>
        </div>

        <!-- step -->
        <div class="pop-process">
          <van-steps
            class="pop-step"
            :active="active"
            active-icon="play"
            active-color="#f13c3c"
          >
            <van-step>
              <div>移动积分</div>
              <p style="padding: 0; margin: 0">
                {{ popupProduct.points * stepCountVal }}积分
              </p>
            </van-step>
            <van-step>
              <div>磁石</div>
              <div style="margin-bottom: 10px">
                {{ popupProduct.threeValue * stepCountVal }}磁石
              </div>
            </van-step>
            <van-step>
              <div>商品</div>
              <div style="margin-bottom: 10px">兑换</div>
            </van-step>
          </van-steps>
        </div>

        <div class="pop-header-tiplab">
          短信验证码已发送，请注意查收由中国移动积分商城发送的短信验证码。
        </div>

        <!-- button -->
        <div style="padding-top: 10px">
          <div class="pop-title">
            <span class="pop-title-lab">验证码确认</span>
          </div>
          <div class="pop-info">
            <van-image
              fit="cover"
              class="pop-icon"
              :src="require('../../static/images/mobile-phone.png')"
            />
            <span class="pop-mobile">{{ account }}</span>
          </div>
          <div class="pop-info">
            <van-image
              fit="cover"
              class="pop-icon"
              :src="require('../../static/images/vcode.png')"
            />
            <van-field
              v-model="smsCode"
              size="large"
              placeholder="请输入验证码"
              class="pop-val"
              maxlength="6"
              clearable
            >
              <template #button>
                <van-button
                  size="small"
                  @click="handleSendSMS"
                  :disabled="isCountDown"
                  >{{ countdownLab }}</van-button
                >
              </template>
            </van-field>
          </div>
        </div>

        <div class="pop-bottom">
          <van-button
            class="pop-btn"
            round
            color="#FF533C"
            @click="handlePayConfirm"
          >
            确认兑换
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup
      v-model="showResPopup"
      position="center"
      :close-on-click-overlay="false"
      :style="{ minHeight: '360px', width: '80%' }"
      round
    >
      <div class="pop-result">
        <van-image
          fit="cover"
          class="pop-result-header"
          :src="require('../../static/images/success_icon.png')"
        />

        <van-image
          fit="cover"
          class="pop-result-icon"
          :src="require('../../static/images/success_gou_icon.png')"
        />

        <van-image
          fit="cover"
          class="pop-result-lab"
          :src="require('../../static/images/success-icon.png')"
        />

        <div class="pop-result-submit" @click="handleOk">确认</div>
      </div>
    </van-popup>

    <!-- 退出登录 -->
    <van-action-sheet
      v-model="showActionSheet"
      :actions="actions"
      cancel-text="取消"
      description="确认退出登录？"
      close-on-click-action
      @select="onActionSheetSelect"
    />
  </div>
</template>

<script>
import {
  Row,
  Col,
  NavBar,
  Image,
  Button,
  Field,
  Popup,
  Step,
  Steps,
  PullRefresh,
  SubmitBar,
  Stepper,
  Icon,
  Divider,
  RadioGroup,
  Radio,
  ActionSheet,
} from "vant";
import {
  memberInfo,
  queryCmccBalance,
  getProduct,
  placeOrder,
  dectOrder,
  sendCmccSms,
  getStoreChannelInfo,
} from "@/api/global";

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Button.name]: Button,
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Step.name]: Step,
    [Steps.name]: Steps,
    [PullRefresh.name]: PullRefresh,
    [SubmitBar.name]: SubmitBar,
    [Stepper.name]: Stepper,
    [Icon.name]: Icon,
    [Divider.name]: Divider,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [ActionSheet.name]: ActionSheet,
  },

  data() {
    return {
      account: null,
      points: 0,
      exchangeVal: 0,
      showPopup: false,
      showResPopup: false,
      showConfirmPopup: false,

      smsCode: null,
      active: 4,
      stepVal: 0,
      buyCount: 1,
      needPoints: 0,
      productInfo: {},
      reqOrderId: null,
      isCountDown: false,
      countdownLab: "发送验证码",
      timer: null,

      isProduct: true,

      isLoading: false,
      loadingMore: false,
      finished: false,
      productList: [],
      popupProduct: {},
      stepCountVal: 1,

      radio: "1",

      storeInfo: {},

      showActionSheet: false,
      actions: [{ name: "确认退出", color: "#ee0a24" }],
    };
  },

  created() {
    window.merId = this.$route.query.merId;
    window.storeId = this.$route.query.storeId;
    window.channelCode = this.$route.query.channelCode;

    this.account = localStorage.getItem("pm_mobile");
    console.log("code >>> ", this.$route.query.channelCode);
  },

  mounted() {
    const _this = this;
    memberInfo()
      .then((res) => {
        console.log('memberInfo >>> ')
        _this.initLoadData();
      })
      .catch((err) => {
        if (err.status == 401) {
          _this.$toast("登录失效，请重新登录");

          let query = _this.$route.query;
          if (_this.$route.query.channelCode) {
            query.channelCode = _this.$route.query.channelCode;
          }

          if (_this.$route.query.id) {
            query.id = _this.$route.query.id;
          }

          if (_this.$route.query.merId) {
            query.merId = _this.$route.query.merId;
          }

          if (_this.$route.query.storeId) {
            query.storeId = _this.$route.query.storeId;
          }

          if (_this.$route.query.ddback) {
            query.ddback = _this.$route.query.ddback;
          }

          _this.$router.replace({
            path: "/",
            query,
          });
        }
      });
  },

  computed: {
    submitBarText() {
      const count = this.checkedGoods.length;
      return "结算" + (count ? `(${count})` : "");
    },

    totalPrice() {
      return this.goods.reduce(
        (total, item) =>
          total + (this.checkedGoods.indexOf(item.id) !== -1 ? item.price : 0),
        0
      );
    },
  },

  methods: {
    initLoadData() {
      let data = {};
      if (this.$route.query.channelCode) {
        data.channelCode = this.$route.query.channelCode;
      }

      if (this.$route.query.id) {
        data.transCode = this.$route.query.id;
      }

      if (this.$route.query.merId) {
        data.merId = this.$route.query.merId;
      }

      if (this.$route.query.storeId) {
        data.storeId = this.$route.query.storeId;
      }

      if (this.$route.query.ddback) {
        data.ddback = this.$route.query.ddback;
      }

      getStoreChannelInfo(data).then((res) => {
        if (res) {
          this.storeInfo = res.store || {};
        }
      });

      queryCmccBalance(data).then((res) => {
        console.log("queryCmccBalance >>> ", res);
        // if (res.resultCode && res.resultCode == "B002") {
        if (res) {
          if (
            res.resultCode != "9999" &&
            res.authUrl &&
            res.authUrl.length > 0
          ) {
            // window.location = "https://test-m-stg3.ppppoints.com/event/2019/blankPage/index.html?interCode=CYS0001&character=00&ipAddress=172.110.1.20&partnerId=S9999073&requestId=8888888888888888888&reqTime=20220712&signType=MD5&type=mobile&version=1.0.0&mobile=13584778906&outTokenId=S99999913584778906_out&outType=00&callbackUrl=http%3A%2F%2Fwww.njjiaoteng.com%2Fredirect.do&channelSource=02000000&reserved1=&reserved2=&hmac=fcf73165a6d9af2df41055d7406cc5ec";
            window.location = `${res.authUrl}`;
          } else {
            this.points = res.points || 0;

            // this.calcExchangeVal()
          }
        }
      });

      getProduct({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        console.log("res >>>> ", res);
        if (res.records && res.records.length > 0) {
          this.productList = res.records || [];
        }

        this.isLoading = false;
      });
    },

    onRefresh() {
      this.getProduct();
    },

    onLoad() {
      this.getProduct();
    },

    formatPrice(price) {
      return (price / 100).toFixed(2);
    },

    startCountDown() {
      const _t = this;
      let initVal = 60;
      this.timer = setInterval(() => {
        if (initVal <= 0) {
          _t.isCountDown = false;
          _t.countdownLab = "获取验证码";

          clearInterval(_t.timer);
          return;
        }

        initVal -= 1;
        _t.countdownLab = initVal + "s";
      }, 1000);
    },

    // 选择兑换商品
    handleProduct(item) {
      this.popupProduct = Object.assign({}, item);
      this.showConfirmPopup = true;
    },

    handleBack() {
      this.$router.back();
    },

    handleOk() {
      this.$router.replace("/");
    },

    handleRecord() {
      let query = this.$route.query;
      if (this.$route.query.channelCode) {
        query.channelCode = this.$route.query.channelCode;
      }

      if (this.$route.query.id) {
        query.id = this.$route.query.id;
      }

      if (this.$route.query.merId) {
        query.merId = this.$route.query.merId;
      }

      if (this.$route.query.storeId) {
        query.storeId = this.$route.query.storeId;
      }

      if (this.$route.query.ddback) {
        query.ddback = this.$route.query.ddback;
      }
      this.$router.push({
        path: "/record",
        query,
      });
    },

    onActionSheetSelect(e, i) {
      if (i == 0) {
        this.logout();
      }
    },

    logout() {
      localStorage.removeItem("pm_login_token");
      localStorage.removeItem("pm_mobile");

      let query = this.$route.query;
      if (this.$route.query.channelCode) {
        query.channelCode = this.$route.query.channelCode;
      }

      if (this.$route.query.id) {
        query.id = this.$route.query.id;
      }

      if (this.$route.query.merId) {
        query.merId = this.$route.query.merId;
      }

      if (this.$route.query.storeId) {
        query.storeId = this.$route.query.storeId;
      }

      if (this.$route.query.ddback) {
        query.ddback = this.$route.query.ddback;
      }

      this.$router.replace({
        path: "/exchange",
        query,
      });
    },

    handleSendSMS() {
      if (!this.reqOrderId) {
        this.$toast("无法查询订单信息，请稍后再试");
        return;
      }

      sendCmccSms({
        reqOrderId: this.reqOrderId,
      }).then(() => {
        this.isCountDown = true;
        this.startCountDown();
      });
    },

    // 下单
    handleConfirm() {
      console.log("sid >>> ", window.sessionId, window.blackbox);

      if (!window.sessionId) {
        this.$toast("服务初始异常");
        return;
      }

      if (!window.blackbox) {
        this.$toast("服务初始异常");
        return;
      }

      if (!this.popupProduct.goodsNo) {
        this.$toast("商品数据获取异常，请刷新");
        return;
      }

      if (this.points < this.popupProduct.points * this.stepCountVal) {
        this.$toast("当前可用积分不足，无法兑换！");
        return;
      }

      if (this.radio == 2) {
        this.$toast("内测中，敬请期待！");
        return;
      }

      let data = {
        fingerprint: window.blackbox,
        goodsInfo: [
          {
            goodsNo: this.popupProduct.goodsNo,
            goodsNum: this.stepCountVal,
          },
        ],
        totalPoints: this.popupProduct.points * this.stepCountVal,
        sessionid: window.sessionId,
      };

      if (this.$route.query.channelCode) {
        data.channelCode = this.$route.query.channelCode;
      }

      if (this.$route.query.id) {
        data.transCode = this.$route.query.id;
      }

      placeOrder(data).then((res) => {
        if (res) {
          this.reqOrderId = res.requestId;
          this.isCountDown = true;
          this.startCountDown();

          this.showPopup = true;
        }
      });
    },

    handlePayConfirm() {
      if (!this.reqOrderId) {
        this.$toast("无法查询订单信息，请稍后再试");
        return;
      }

      if (!this.smsCode || this.smsCode.length == 0) {
        this.$toast("请输入验证码");
        return;
      }

      dectOrder({
        fingerprint: window.blackbox,
        reqOrderId: this.reqOrderId,
        smsCode: this.smsCode,
        sessionid: window.sessionId,
      }).then(() => {
        let query = this.$route.query;
        query.orderId = this.reqOrderId;

        if (this.$route.query.channelCode) {
          query.channelCode = this.$route.query.channelCode;
        }

        if (this.$route.query.id) {
          query.id = this.$route.query.id;
        }

        if (this.$route.query.merId) {
          query.merId = this.$route.query.merId;
        }

        if (this.$route.query.storeId) {
          query.storeId = this.$route.query.storeId;
        }


        if (this.$route.query.ddback) {
          query.ddback = this.$route.query.ddback;
        }

        this.$router.push({
          path: "/res",
          query,
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  background-color: #f5f5f5;
  min-height: 100vh;
}

:deep(.van-nav-bar__content) {
  background-color: #ff533c;
}

:deep(.van-nav-bar__title) {
  color: #fff !important;
}

:deep(.van-icon) {
  color: #fff !important;
}

.content {
  position: relative;

  margin-top: -60px;

  &-header {
    width: 100%;
    height: 200px;
  }
}

.user-info {
  background-color: #fff;
  box-shadow: 0px 0px 5px #ddd;
  border-radius: 10px;
  margin: 20px 20px 10px;
  padding: 20px;

  &-header {
    display: flex;
    align-items: center;
  }
}

.store-info {
  display: flex;
  align-items: center;
  padding-bottom: 10px;

  &-name {
    font-size: 15px;
    font-weight: 600;
    color: #333;
  }

  &-address {
    font-size: 12px;
    color: #999;
    padding-top: 2px;
  }
}

.account-mobile {
  font-size: 18px;
  font-weight: 600;
  color: #333;

  display: flex;
  align-items: center;
  justify-content: space-between;

  &-logout {
    margin-right: -8px;
    font-size: 10px;
    color: #ff533c;
    font-weight: 600;
  }
}

.account {
  width: 50px;
  height: 50px;
  padding-right: 10px;

  &-exchange-tip {
    color: #999;
    font-size: 13px;
    padding-top: 8px;
  }
}

// .account-panel {
//   background-color: #f5f5f5;
//   padding: 10px;
//   margin: 5px;
// }

.account-descr {
  color: #666;
  font-size: 13px;
  padding-top: 8px;
  display: flex;
  align-items: center;

  &-picon {
    width: 15px;
    height: 15px;
  }

  &-points {
    color: #ff533c;
    font-size: 15px;
    font-weight: 600;
  }
}

.points {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 20px;

  &-title {
    display: flex;
    align-items: center;

    &-icon {
      width: 20px;
      height: 15px;
    }

    &-lab {
      padding-left: 5px;
      font-size: 12px;
      color: rgba(255, 255, 255, 1);
    }
  }

  &-count {
    color: #fff;
    font-size: 24px;
    font-weight: 600;
    padding-top: 5px;
  }
}

.pop {
  position: relative;
  height: 100%;
  background-color: #fff;

  &-header {
    background-color: #ff533c;
    color: #fff;
    height: 48px;
    width: 100%;

    &-title {
      width: 100%;
      height: 48px;
      line-height: 48px;
      color: #fff;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
    }

    &-tiplab {
      padding: 0px 20px 0;
      font-size: 14px;
      color: #666;
    }
  }

  &-process {
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &-step {
    width: 80%;
  }

  &-info {
    display: flex;
    align-items: center;
    border-bottom: 0.5px solid #ddd;
    padding: 10px 0;
  }

  &-mobile {
    padding: 15px 0px;
    padding-left: 10px;
    font-size: 17px;
    font-weight: 600;
  }

  &-icon {
    width: 25px;
    height: 25px;
    padding-left: 20px;
  }

  &-val {
    font-size: 17px;
    font-weight: 600;
  }

  &-title {
    &-lab {
      margin-top: 30px;
      color: #666;
      padding: 0 20px;
      font-size: 13px;
    }
  }

  &-bottom {
    padding-top: 30px;
    display: flex;
    justify-content: center;
  }

  &-btn {
    width: 80%;
  }
}

.pop-result {
  position: relative;

  &-header {
    width: 100%;
    z-index: 99;
  }

  &-icon {
    position: absolute;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 199;
  }

  &-lab {
    position: absolute;
    top: 250px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 199;
  }

  &-submit {
    position: absolute;
    width: 100%;
    bottom: -120px;
    font-size: 14px;
    color: #666;
    text-align: center;
  }
}

:deep(.van-field__control) {
  color: #f56c13;
}

.info-exchange-panel {
  padding-top: 15px;
  display: flex;
  justify-content: center;
}
.info-exchange-title {
  width: 140px;
}

.product-item {
  background-color: #fff;
  width: 46%;
  display: inline-block;
  margin-left: 10px;
  margin-top: 5px;
  border-radius: 8px;
  overflow: hidden;

  &-img {
    width: 100%;
    height: 140px;
  }

  &-title {
    padding: 5px 10px 0;
    font-size: 14px;
  }

  &-points {
    font-size: 14px;
    color: #fbae54;
    padding: 0 10px 5px;
  }

  &-btn {
    padding: 10px 10px 15px;
    font-size: 12px;
    text-align: center;
  }

  &-span {
    padding: 6px 14px;
    color: #fff;
    border-radius: 5px;
    background-color: #f7913f;
  }
}

.pop-product-item {
  padding: 20px;

  &-img {
    width: 80px;
    height: 80px;
    border-radius: 8px;
  }

  &-title {
    font-size: 18px;
    font-weight: 600;
    padding-top: 15px;
  }

  &-point {
    padding-top: 5px;
    font-size: 17px;
    color: #fbae54;
  }

  &-count {
    padding-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-tiplab {
    color: #333;
    font-size: 15px;
  }
}

.coupon-bg {
  background: linear-gradient(to bottom, #ffc74d, #ffebab);
  margin: 0 15px 0;
  padding-bottom: 20px;
  border-radius: 10px;
}

.coupon-bg-header {
  width: 100%;
  display: flex;
  justify-content: center;

  &-title {
    padding: 20px 0 10px;
    width: 120px;
  }
}

.coupon-bg-panel {
  min-height: 300px;
  background-image: url("../../static/images/v3/coupon-bg-02.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 30px 20px 0px;
  margin: 0 15px 0;
}

.coupon-bg-img {
  min-height: 80px;
  background-image: url("../../static/images/v3/coupon-single-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}

.coupon-change-item {
  background-image: url("../../static/images/v3/coupon-change-bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-left: 5%;
  width: 26%;
  min-height: 80px;
  display: inline-block;
}

.exchange-record {
  position: absolute;
  right: 30px;
  bottom: 15px;

  &-icon {
    width: 20px;
    height: 20px;
  }
}

/deep/ .van-step__circle-container {
  margin-top: 20px !important;
}

/deep/ .van-step__line {
  margin-top: 20px !important;
}

/deep/ .van-step__circle-container .van-icon {
  color: red !important;
}
</style>
